<script lang="ts">
  export let tweetId: string;
</script>

<div class="tweet-embed">
  <!-- Placeholder sizing is based on a tweet with embedded media -->
  <blockquote
    class="twitter-tweet bg-gray-900 min-h-[576px] animate-pulse rounded-md my-[10px]"
    data-theme="dark"
  >
    <a
      href="https://twitter.com/_/status/{tweetId}"
      aria-label="View tweet on Twitter"
    ></a>
    <!-- Header (avatar and handle) -->
    <div class="flex items-center mb-5">
      <div class="w-[48px] h-[48px] bg-gray-800 rounded-md"></div>
      <div class="ml-3">
        <div class="h-3 w-12 bg-gray-800 rounded-full"></div>
        <div class="h-3 w-20 bg-gray-800 rounded-full mt-1"></div>
      </div>
    </div>

    <!-- Text content -->
    <div class="w-full h-5 bg-gray-800 rounded-lg mb-1"></div>
    <div class="w-full h-5 bg-gray-800 rounded-lg mb-1"></div>
    <div class="w-2/3 h-5 bg-gray-800 rounded-lg mb-5"></div>

    <!-- Media (video or image) -->
    <div class="w-full h-[300px] bg-gray-800 rounded-lg mb-5"></div>

    <!-- Footer (likes, retweets, etc.) -->
    <div class="w-1/3 h-5 bg-gray-800 rounded-lg mb-1"></div>
    <div class="w-1/2 h-5 bg-gray-800 rounded-lg mb-3"></div>
    <div class="w-full h-5 bg-gray-800 rounded-full mx-auto"></div>
  </blockquote>
</div>

<svelte:head>
  <script
    src="https://platform.twitter.com/widgets.js"
    charset="utf-8"
  ></script>
</svelte:head>

<style lang="postcss">
  .tweet-embed {
    max-width: 560px;
    margin: auto;
    display: grid;
  }

  :global(.twitter-tweet) {
    border-radius: 12px;
    overflow: hidden;
    border-left: none !important;
    grid-column: 1;
    grid-row: 1;
  }
</style>
